import React from 'react';
import { ITranslateMethod } from '@core/js/hooks/i18n/types';
import style from '../index.scss';

type GetRenderAccordionDefaultCell = {
    translate: ITranslateMethod;
}

export const getRenderAccordionDefaultCell = ({ translate }: GetRenderAccordionDefaultCell) =>
    ({ value, name }: { value: string; name: string }) => (
    <>
        <div className={`${style.cellName} accordionBodyCellName`}>{translate(name)}</div>
        <div className={`${style.cellValue} accordionBodyCellValue`}>{value}</div>
    </>
);
